import CustomInputSearch from 'designer/component/element/InputSearch'
import ControlWrapper from './ControlWrapper'

const InputSearchControl = (props) => {
  return <ControlWrapper {...props} Component={CustomInputSearch} />
}

export default InputSearchControl
